// ta-quote-mailchimp.js — sessionStorage + contact_posted flow
(function () {
  console.log('[TA→MC] loader: script file loaded');

  var STORAGE_KEY = 'ta_mc_quote_data_v1';

  // ---------- helpers ----------
  function q(sel, root){ return (root || document).querySelector(sel); }

  function byPlaceholder(needles, root){
    root = root || document;
    needles = Array.isArray(needles) ? needles : [needles];
    var sel = needles.map(function (t) {
      return 'input[placeholder*="' + t + '" i], textarea[placeholder*="' + t + '" i]';
    }).join(',');
    return q(sel, root);
  }

  function byLabel(needle, root){
    root = root || document;
    needle = (needle || '').toLowerCase();
    var labels = root.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      var txt = (labels[i].textContent || '').trim().toLowerCase();
      if (!needle || txt.includes(needle)) {
        var forId = labels[i].getAttribute('for');
        if (forId) {
          var el = root.querySelector('#' + CSS.escape(forId));
          if (el) return el;
        }
        var next = labels[i].nextElementSibling;
        while (next && next.tagName && !/^(INPUT|TEXTAREA|SELECT)$/i.test(next.tagName)) {
          next = next.nextElementSibling;
        }
        if (next) return next;
      }
    }
    return null;
  }

  function findConsent(root){
    root = root || document;
    // Prefer explicit name if we set it
    var box = root.querySelector('input[name="subscribe_newsletter"]');
    if (box) return box;
    // Fallback: label starting "Keep me informed"
    var boxes = root.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < boxes.length; i++) {
      var label = boxes[i].closest('label') || boxes[i].parentElement;
      var text = (label && label.textContent) ? label.textContent.trim().toLowerCase() : '';
      if (text.startsWith('yes, i\’d like to receive')) return boxes[i];
    }
    return null;
  }

  function ensure(v, fallback){ v = (v || '').trim(); return v ? v : fallback; }

  // ---------- collect current form state from DOM ----------
  function collectCurrentData(){
    var root = document;

    // Email
    var emailEl = q('input[type="email"]', root) ||
                  byPlaceholder(['email','mail'], root) ||
                  byLabel('email', root);

    var email = emailEl ? emailEl.value.trim() : '';

    // Name
    var firstEl = byPlaceholder(['first name','given','first'], root) || byLabel('first name', root);
    var lastEl  = byPlaceholder(['last name','surname','last'], root) || byLabel('last name', root);
    var fullEl  = byPlaceholder(['full name','your name'], root)      || byLabel('full name', root);

    var fname = firstEl ? firstEl.value.trim() : '';
    var lname = lastEl  ? lastEl.value.trim()  : '';

    if ((!fname || !lname) && fullEl && fullEl.value) {
      var parts = fullEl.value.trim().split(/\s+/);
      if (!fname) fname = parts[0] || '';
      if (!lname) lname = parts.slice(1).join(' ');
    }
    fname = ensure(fname, '-');
    lname = ensure(lname, '-');

    // Optional
    var companyEl = byPlaceholder('company', root) || byLabel('company', root);
    var titleEl   = byPlaceholder('title',   root) || byLabel('title',   root);

    var consentBox = findConsent(root);
    var consent    = !!(consentBox && consentBox.checked);

    return {
      email:   email,
      fname:   fname,
      lname:   lname,
      company: companyEl ? companyEl.value.trim() : '',
      title:   titleEl   ? titleEl.value.trim()   : '',
      consent: consent
    };
  }

  // ---------- Mailchimp submit from stored data ----------
  function submitMailchimpFromStored(stored){
    var mcForm = document.getElementById('mc-embed-form');
    if (!mcForm) {
      console.log('[TA→MC] abort: hidden Mailchimp form not found');
      return;
    }
    if (!stored || !stored.email) {
      console.log('[TA→MC] abort: no stored email');
      return;
    }

    var set = function (name, val) {
      var el = mcForm.querySelector('[name="'+name+'"]');
      if (el) el.value = val || '';
    };

    set('EMAIL',  stored.email);
    set('FNAME',  stored.fname || '-');
    set('LNAME',  stored.lname || '-');
    set('MMERGE6', stored.company || '');
    set('MMERGE7', stored.title   || '');

    console.log('[TA→MC] submit → Mailchimp from stored data', stored);
    mcForm.submit();
  }

  // ---------- 1) While the user is on the form page ----------
  // On any input/change, capture latest data into sessionStorage
  function handleFieldChange(){
    var data = collectCurrentData();
    if (!data.email) {
      // no email yet – nothing useful to store
      return;
    }
    // Always store, but mark consent state
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        email:   data.email,
        fname:   data.fname,
        lname:   data.lname,
        company: data.company,
        title:   data.title,
        consent: data.consent,
        sent:    false
      }));
      // console.log('[TA→MC] stored data', data);
    } catch (e) {
      console.warn('[TA→MC] could not store data in sessionStorage', e);
    }
  }

  document.addEventListener('input', handleFieldChange, true);
  document.addEventListener('change', handleFieldChange, true);

  // ---------- 2) After successful contact submission ----------
  // PageFly / Shopify append ?contact_posted=true on success.
  function onLoadCheck(){
    var search = window.location.search || '';
    if (search.indexOf('contact_posted=true') === -1) {
      return; // not the "thank you / posted" state
    }

    var raw = null, stored = null;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
      stored = raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.warn('[TA→MC] error reading stored data', e);
    }

    if (!stored) {
      console.log('[TA→MC] no stored data found after contact_posted');
      return;
    }
    if (stored.sent) {
      console.log('[TA→MC] stored data already sent, skipping');
      return;
    }
    if (!stored.consent) {
      console.log('[TA→MC] stored data has no consent, skipping');
      return;
    }

    // We have: contact_posted=true, stored data, consent = true → send to Mailchimp
    submitMailchimpFromStored(stored);

    // mark as sent
    stored.sent = true;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {}
  }

  // Run the check shortly after load (DOM is ready)
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    onLoadCheck();
  } else {
    document.addEventListener('DOMContentLoaded', onLoadCheck);
  }

})();